<lvr-heading>{{ 'client.disability.proof_form.update' | transloco }}</lvr-heading>
<form [formGroup]="form" lvrAutoSave="disabilityProof" [entityId]="draftId()" [autoLoad]="false">
	<section class="form">
		<!-- Column 1 -->
		<div class="form-group">
			<!-- Date of SB-Ausweis -->
			@let sbProofCtrl = form.get('dateSbProof');
			<lvr-field
				[label]="'client.disability.proof_form.dateSbProof' | transloco | appendAsterisk"
				[matTooltip]="'client.disability.proof_form.sb_hint' | transloco"
			>
				@if (canEdit('dateSbProof')) {
					<mat-form-field
						lvrInput
						[lvrError]="hasError(sbProofCtrl, 'maxDateExceeded', 'required', 'matDatepickerParse', 'dateTaken')"
					>
						<input
							matInput
							[matDatepicker]="picker"
							[max]="maxSbProofDate"
							formControlName="dateSbProof"
							placeholder="04.06.2013"
							[errorStateMatcher]="matcher"
						/>
						@if (hasError(sbProofCtrl, 'matDatepickerParse')) {
							<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
						} @else if (hasError(sbProofCtrl, 'dateTaken')) {
							<mat-error>{{ 'base.form.error.date_taken' | transloco }}</mat-error>
						} @else if (hasError(sbProofCtrl, 'maxDateExceeded')) {
							<mat-error>{{ 'client.disability.proof_form.sb_present' | transloco }}</mat-error>
						} @else if (hasError(sbProofCtrl, 'required')) {
							<mat-error>{{ 'client.disability.proof_form.required' | transloco }}</mat-error>
						}
						<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
						<mat-hint>{{ dateFormatHint }}</mat-hint>
					</mat-form-field>
				} @else {
					<p class="readonly">{{ proof().since | date: dateDisplayFormat }}</p>
				}
			</lvr-field>

			<!-- SB-Status -->
			@let sbStatusCtrl = form.get('sbStatus');
			<lvr-field [label]="'client.disability.proof_form.sbstatus' | transloco | appendAsterisk">
				@if (canEdit('sbStatus')) {
					<lvr-searchable-select
						formControlName="sbStatus"
						[options]="disabilityStatus()"
						[placeholder]="'base.field.select_please' | transloco"
						[searchPlaceholder]="'base.field.search_placeholder' | transloco"
						[noResultsText]="'base.field.no_results' | transloco"
						[ariaLabel]="'client.disability.proof_form.sbstatus' | transloco"
						[required]="true"
						[hasError]="hasError(sbStatusCtrl, 'required')"
						[errorMessage]="'client.disability.proof_form.required' | transloco"
					></lvr-searchable-select>
				} @else {
					<p class="readonly">{{ proof().status.content }}</p>

					@if (!proof().status.limitedUntil) {
						<p class="readonly">{{ 'client.disability.no_limit' | transloco }}</p>
					}
				}
			</lvr-field>
			<!-- Sonstiges text -->
			@if (shouldDisplayOtherText()) {
				@let otherTextCtrl = form.get('otherText');
				<lvr-field [label]="'client.disability.proof_form.other_text' | transloco | appendAsterisk">
					<mat-form-field
						lvrInput
						[lvrError]="hasError(otherTextCtrl, 'required')"
						[attr.aria-label]="'client.disability.proof_form.other_text' | transloco"
					>
						<input
							matInput
							maxlength="maxOtherTextLength"
							formControlName="otherText"
							placeholder="Sonstiges Freitextfeld"
							[errorStateMatcher]="matcher"
						/>

						@if (hasError(otherTextCtrl, 'required')) {
							<mat-error>{{ 'base.form.error.required' | transloco }}</mat-error>
						}
						<mat-hint>{{
							'client.relatives.create.hint.maxlength'
								| transloco: { actual: otherTextCtrl?.value?.length || 0, max: maxOtherTextLength }
						}}</mat-hint>
					</mat-form-field>
				</lvr-field>
			}

			<!-- Limited / unlimited -->
			@if (!shouldDurationBeOptional()) {
				@let limitedCtrl = form.get('limited');
				@if (canEdit('limitedUntil')) {
					<lvr-field [label]="'client.disability.proof_form.select_limited' | transloco | appendAsterisk">
						<div>
							@if (limitedCtrl?.hasError('required')) {
								<mat-error class="radio-group-error">{{
									'client.disability.proof_form.required' | transloco
								}}</mat-error>
							}
						</div>
						<mat-radio-group
							formControlName="limited"
							[attr.aria-label]="'client.disability.proof_form.select_limited' | transloco"
						>
							<mat-radio-button value="1">
								{{ 'client.disability.proof_form.unlimited_option' | transloco }}
							</mat-radio-button>
							<mat-radio-button value="2">
								{{ 'client.disability.proof_form.limited_option' | transloco }}
							</mat-radio-button>
						</mat-radio-group>
					</lvr-field>
				}

				<!-- Expiry date for limit -->
				@if (limitedCtrl?.value === '2') {
					@let limitedUntilCtrl = form.get('limitedUntil');
					<lvr-field [label]="'client.disability.proof_form.limitedUntil' | transloco | appendAsterisk">
						@if (canEdit('limitedUntil')) {
							<mat-form-field
								lvrInput
								[lvrError]="
									hasError(limitedUntilCtrl, 'maxDateExceeded', 'dateRangeExceeded', 'required', 'matDatepickerParse')
								"
							>
								<input
									matInput
									[matDatepicker]="limitedPicker"
									[min]="minLimitedDate"
									[max]="maxLimitedDate"
									formControlName="limitedUntil"
									placeholder="04.06.2013"
									[errorStateMatcher]="matcher"
								/>
								@if (hasError(limitedUntilCtrl, 'matDatepickerParse')) {
									<mat-error>{{
										'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint }
									}}</mat-error>
								} @else if (hasError(limitedUntilCtrl, 'required')) {
									<mat-error>{{ 'client.disability.proof_form.required' | transloco }}</mat-error>
								} @else if (hasError(limitedUntilCtrl, 'maxDateExceeded')) {
									<mat-error>{{ 'client.disability.proof_form.sb_max' | transloco: { max: 50 } }}</mat-error>
								} @else if (hasError(limitedUntilCtrl, 'dateRangeExceeded')) {
									<mat-error>{{ 'client.disability.proof_form.sb_range' | transloco }}</mat-error>
								}
								<mat-datepicker-toggle matIconSuffix [for]="limitedPicker"></mat-datepicker-toggle>
								<mat-datepicker #limitedPicker></mat-datepicker>
								<mat-hint>{{ dateFormatHint }}</mat-hint>
							</mat-form-field>
						} @else {
							<p class="readonly">{{ proof().status.limitedUntil | date: dateDisplayFormat }}</p>
						}
					</lvr-field>
				}
			}

			<!-- GbB Value -->
			@let gdbCtrl = form.get('gdbValue');
			<lvr-field [label]="'client.disability.proof_form.gdbValue' | transloco | appendAsterisk">
				@if (canEdit('gdbValue')) {
					<lvr-searchable-select
						formControlName="gdbValue"
						[options]="gdBValues()"
						[placeholder]="'base.field.select_please' | transloco"
						[searchPlaceholder]="'base.field.search_placeholder' | transloco"
						[noResultsText]="'base.field.no_results' | transloco"
						[ariaLabel]="'client.disability.proof_form.gdbValue' | transloco"
						[required]="true"
						[hasError]="hasError(gdbCtrl, 'required')"
						[errorMessage]="'client.disability.proof_form.required' | transloco"
						[hintText]="'client.disability.proof_form.gdb_value_hint' | transloco"
					></lvr-searchable-select>
				} @else {
					<p class="readonly">{{ proof().categoryDisabilitySeverity.remark }}</p>
				}
			</lvr-field>

			<!-- Document Files -->
			@let filesCtrl = form.get('documents');
			@if (canEdit('documents') && hasEditable() && proof().documents.length < PROOF_SETTINGS.maxFiles) {
				<lvr-field [label]="'client.disability.proof_form.documents' | transloco">
					<ul>
						@for (doc of proof().documents; track doc.id) {
							<li>{{ doc.name }}</li>
						}
					</ul>
					<lvr-document-upload
						[maxFileCount]="remainingDocumentSlots()"
						[hasError]="hasFileError(filesCtrl, 'requiredFile', 'maxFiles', 'maxFileSize', 'allowedFileTypes')"
						[multiple]="true"
						formControlName="documents"
						[showIcon]="true"
						[ownerId]="client().uuid"
						[maxFileSize]="maxFileSize"
						[subjectType]="subjectType"
					>
					</lvr-document-upload>
				</lvr-field>
			} @else if (canEdit('documents') && hasEditable() && proof().documents.length >= PROOF_SETTINGS.maxFiles) {
				<lvr-field [label]="'client.disability.proof_form.documents' | transloco">
					<ul>
						@for (doc of proof().documents; track doc.id) {
							<li>{{ doc.name }}</li>
						}
					</ul>
				</lvr-field>
			} @else if (canEdit('documents')) {
				<lvr-document-upload
					[maxFileCount]="remainingDocumentSlots()"
					[subjectType]="subjectType"
					[hasError]="hasFileError(filesCtrl, 'requiredFile', 'maxFiles', 'maxFileSize', 'allowedFileTypes')"
					[multiple]="true"
					formControlName="documents"
					[showIcon]="true"
					[ownerId]="client().uuid"
					[maxFileSize]="maxFileSize"
				>
				</lvr-document-upload>
			}
		</div>

		<!-- Column 2 -->
		<div class="form-group">
			<!-- Remark field -->
			@let remarkCtrl = form.get('remark');
			<lvr-field [label]="'base.field.remark' | transloco">
				@if (canEdit('remark')) {
					<mat-form-field lvrInput [lvrError]="hasError(remarkCtrl, 'max')">
						<textarea
							matInput
							formControlName="remark"
							[placeholder]="'base.field.remark_placeholder' | transloco"
							[errorStateMatcher]="matcher"
							[maxlength]="maxRemarkLength"
						></textarea>
						@if (hasError(remarkCtrl, 'max')) {
							<mat-error>{{ 'base.form.error.max_length_exceeded' | transloco: { max: maxRemarkLength } }}</mat-error>
						}
						<mat-hint>{{
							'base.field.remark_hint' | transloco: { actual: remarkCtrl?.value?.length || 0, max: maxRemarkLength }
						}}</mat-hint>
					</mat-form-field>
				} @else {
					<p class="readonly">{{ proof().remark }}</p>
				}
			</lvr-field>
		</div>

		<p lvrPadding [padHorizontal]="16" [padVertical]="0">{{ 'base.form.required' | transloco }}</p>
	</section>

	<lvr-default-actions
		[disableSave]="form.invalid || !canEditDisabilityReportsPermission()"
		[showLoading]="isLoading()"
		(save)="update()"
		(cancelSave)="cancel()"
	>
		<lvr-restore-actions entityType="disabilityProof" [entityId]="draftId()"></lvr-restore-actions>
	</lvr-default-actions>
</form>
